export default __webpack_public_path__ + "assets/images/a53c01e4a303c52e3a99ba59bc72077e.svg";